const accountIds = includedDistributionAccounts =>
  (includedDistributionAccounts || []).map(({ AccountId }) => AccountId);

export const withDisplayedDistributionOrder = (whatIf, includedDistributionAccounts) => ({
  ...whatIf,
  IncludedDistributionAccounts: accountIds(includedDistributionAccounts),
  DistributionsIsCustom: true,
});

export const withEffectiveDistributionOrder = (whatIf, includedDistributionAccounts) => {
  const includedAccountIds = accountIds(includedDistributionAccounts);

  if (whatIf.DistributionsIsCustom || includedAccountIds.length === 0) {
    return whatIf;
  }

  return {
    ...whatIf,
    IncludedDistributionAccounts: includedAccountIds,
    DistributionsIsCustom: true,
  };
};
